export default {"src":"/_next/static/media/forum-solid.4c6758e1.svg","height":56,"width":56,"blurWidth":0,"blurHeight":0};